import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "./redux";
import {
  authSelector,
  userIdSelector,
  login,
  signup,
} from "../store/slices/authSlice";
import { performLogout } from "../utils/logoutSession";
import type { LoginCredentials, SignupCredentials } from "../types/auth";

export const useAuth = () => {
  const dispatch = useAppDispatch();
  const authState = useAppSelector(authSelector);
  const userId = useAppSelector(userIdSelector);

  const isAuthenticated = Boolean(authState.token);

  const handleLogin = useCallback(
    async (credentials: LoginCredentials) => {
      return dispatch(login(credentials));
    },
    [dispatch]
  );

  const handleSignup = useCallback(
    async (credentials: SignupCredentials) => {
      return dispatch(signup(credentials));
    },
    [dispatch]
  );

  const handleLogout = useCallback(async () => {
    await performLogout(dispatch);
  }, [dispatch]);

  return {
    // State
    token: authState.token,
    refreshToken: authState.refreshToken,
    userId,
    loading: authState.loading,
    error: authState.error,
    isAuthenticated,

    // Actions
    login: handleLogin,
    signup: handleSignup,
    logout: handleLogout,
  };
};
